import { render, staticRenderFns } from "./app-nav-menu.vue?vue&type=template&id=86f89d66&scoped=true"
import script from "./app-nav-menu.vue?vue&type=script&lang=js"
export * from "./app-nav-menu.vue?vue&type=script&lang=js"
import style0 from "./app-nav-menu.vue?vue&type=style&index=0&id=86f89d66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f89d66",
  null
  
)

export default component.exports